
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { BackGroundImageHero, BannerUnSuperAlimento } from '../../components';
import {
    HomeSlider,
    ComoHechosEnCasa,
    ContactUsBanner,
} from '../../components/HomePage';

import PopUpCookies from '../../components/PopUpCookies';
import { Helmet } from 'react-helmet';

import {
    PopupRecetarioDesktop,
    PopupRecetarioMobile
} from '../../assets/images';

import './home.css';


const Home = () => {

    const [mostrarPopup, setMostrarPopup] = useState(true);

    useEffect(() => {
        if (!mostrarPopup) return;

        // Evitar desplazamiento mientras el popup está abierto
        const overflowOriginal = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        // Cerrar con tecla ESC
        const cerrarConEscape = (event) => {
            if (event.key === 'Escape') {
                setMostrarPopup(false);
            }
        };

        window.addEventListener('keydown', cerrarConEscape);

        return () => {
            document.body.style.overflow = overflowOriginal;
            window.removeEventListener('keydown', cerrarConEscape);
        };
    }, [mostrarPopup]);


    return (
        <>
            <Helmet>
                <meta charSet='utf-8' />
                <title>Frijoles Isadora | Los frijoles refritos en bolsa #1 de México</title>
                <meta
                    name="description"
                    content="Conoce Frijoles Isadora, elaborados con recetas caseras, sin conservadores y listos para disfrutar en distintas presentaciones."
                />
                <link rel='canonical' href={window.location.href} />
            </Helmet>

            <BackGroundImageHero />
            <ComoHechosEnCasa />
            <HomeSlider />
            <BannerUnSuperAlimento />
            <ContactUsBanner />
            <PopUpCookies />

            {/* POPUP RECETARIO */}
            {mostrarPopup && createPortal(
                <div className="popup-recetario-overlay">

                    <div
                        className="popup-recetario-contenido"
                        role="dialog"
                        aria-modal="true"
                        aria-label="Recetario Isadora"
                    >

                        {/* Botón cerrar */}
                        <button
                            type="button"
                            className="popup-recetario-cerrar"
                            onClick={() => setMostrarPopup(false)}
                            aria-label="Cerrar popup"
                        >
                            &times;
                        </button>

                        {/* Imagen con enlace a la sección */}
                        <a
                            href="#descargar-recetario"
                            onClick={() => setMostrarPopup(false)}
                            aria-label="Ir a descargar el recetario"
                        >
                            <picture>
                                <source
                                    media="(max-width: 990px)"
                                    srcSet={PopupRecetarioMobile}
                                />

                                <img
                                    src={PopupRecetarioDesktop}
                                    alt="Descarga el recetario Isadora"
                                    className="popup-recetario-imagen"
                                />
                            </picture>
                        </a>

                    </div>
                </div>,
                document.body
            )}

        </>
    );
};

export default Home;
